import { createReducer, on } from '@ngrx/store';
import * as SseActions from '../actions/sse.action';

export interface SseState {
  ridersLocations: any;
  rider: any;
  error: any;
}

export const initialState: SseState = {
  ridersLocations: null,
  rider: null,
  error: null,
};

export const sseReducer = createReducer(
  initialState,
  on(SseActions.getServerSentEventsToOrdersSuccess, (state) => ({
    ...state,
    error: null,
  })),
  on(SseActions.getServerSentEventsToRidersLocationsSuccess, (state, { data }) => ({
    ...state,
    ridersLocations: data,
    error: null,
  })),
  on(SseActions.getServerSentEventsToRiderSuccess, (state, { data }) => ({
    ...state,
    rider: data,
    error: null,
  })),
  on(SseActions.getServerSentEventsToOrdersFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SseActions.getServerSentEventsToRidersLocationsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SseActions.getServerSentEventsToRiderFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);